import axios from "axios";
import { getToken, setToken } from "@/utils/auth";
import { Message } from "element-ui";
import router from "@/router";
import store from "@/store";
import api from "@/apis/api";

const service = axios.create({
  baseURL: api.appBaseUrl,
  timeout: 20000,
});

service.interceptors.request.use(
  (config) => {
    const token = getToken();
    const userInfo = JSON.parse(localStorage.getItem("studentUserInfo"));
    if (token) {
      config.headers["student-Token"] = token;
      setToken(token);
    }
    if (userInfo) {
      config.headers["student-id"] = userInfo.id;
    }
    return config;
  },
  (error) => {
    handleAuthError(error);
    return Promise.reject(error);
  },
);
service.interceptors.response.use(
  (response) => {
    if (response.data.errCode === 2001 || response.data.errCode === 2002) {
      handleAuthError(response);
    } else {
      return response.data;
    }
  },
  (error) => {
    return Promise.reject(error);
  },
);
function handleAuthError(error) {
  store.commit("user/clearUserInfo");
  router.push("/login");
  this.$message.error("请重新登录");
}

export default service;
